export default __webpack_public_path__ + "static/media/Notification-icon.100255d9.svg";